import { getField } from "vuex-map-fields";
export default {
  getContactQuizField(state) {
    return getField(state.quiz);
  },
  getResultStatusField() {
    return function(total) {
      total = Number(total);
      let msg = "";
      console.log("total", total);

      switch (total) {
        case 0:
        case 1:
          msg = "Low risk";
          break;
        case 2:
        case 3:
          msg = "Intermediate Risk";
          break;
        case 4:
        case 5:
        case 6:
          msg = "High risk";
          break;
        case 7:
        case 8:
        case 9:
        case 10:
          msg = "Very high risk";
          break;
        default:
          break;
      }
      return msg;
    };
  },
  getResultStatusFieldKey() {
    return function(total) {
      total = Number(total);
      let msg = "";
      console.log("total", total);

      switch (total) {
        case 0:
        case 1:
          msg = "low";
          break;
        case 2:
        case 3:
          msg = "intermediate";
          break;
        case 4:
        case 5:
        case 6:
          msg = "high";
          break;
        case 7:
        case 8:
        case 9:
        case 10:
          msg = "very_high";
          break;
        default:
          break;
      }
      return msg;
    };
  }
};
